import { CallTime } from '../../model/CallTime';
import playerStore from '../../store/PlayerStore';
import tableStore from '../../store/TableStore';
import { WEvent } from './WEvent';

export class WCallTimeEvent extends WEvent {
  pid: string;
  callTime: CallTime;

  constructor(event: WCallTimeEvent) {
    super(event.tableId, event.eventType, event.eventTime);
    Object.assign(this, event);
  }

  applyWebsocketChanges = (): Promise<void> =>
    tableStore.findActiveTableById(this.tableId).then(table => {
      table.setPlayers(
        playerStore.modifyPlayers(
          table.players,
          this.pid,
          player => (player.callTime = this.callTime),
        ),
      );
    });
}
